
import { useState } from "react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ArrowUpDown } from "lucide-react";

export type SortOption = "recent" | "oldest" | "highestScore" | "lowestScore" | "highestIntegrity" | "candidate" | "date" | "aiScore" | "integrity";

interface SortAndSearchBarProps {
  sortOption: SortOption;
  onSortChange: (option: SortOption) => void;
}

export function SortAndSearchBar({ 
  sortOption, 
  onSortChange 
}: SortAndSearchBarProps) {
  return (
    <Select 
      value={sortOption} 
      onValueChange={(value) => onSortChange(value as SortOption)}
    >
      <SelectTrigger className="w-full h-10 bg-background border border-input hover:bg-accent hover:text-accent-foreground">
        <div className="flex items-center">
          <ArrowUpDown className="mr-2 h-4 w-4" />
          <span className="truncate">
            {sortOption === "recent" && "Most Recent"}
            {sortOption === "oldest" && "Oldest First"}
            {sortOption === "highestScore" && "Highest Score"}
            {sortOption === "lowestScore" && "Lowest Score"} 
            {sortOption === "highestIntegrity" && "Highest Integrity"}
          </span>
        </div>
      </SelectTrigger>
      <SelectContent className="bg-background border shadow-md z-50">
        <SelectItem value="recent">Most Recent</SelectItem>
        <SelectItem value="oldest">Oldest First</SelectItem>
        <SelectItem value="highestScore">Highest Score</SelectItem>
        <SelectItem value="lowestScore">Lowest Score</SelectItem>
        <SelectItem value="highestIntegrity">Highest Integrity</SelectItem>
      </SelectContent>
    </Select>
  );
}
